import React, { Component, PropTypes } from 'react'
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import config from '../../config'
import Loader from 'react-loader'
import CSSModules from 'react-css-modules'
import { asyncConnect } from 'redux-async-connect'
import container from '../../helpers/container'
// import convert from '../../helpers/convert'
import format from '../../helpers/format'
import analytics from '../../helpers/analytics'
import { Row, Col } from 'react-flexbox-grid'
import ReactTooltip from 'react-tooltip'
import { SlideDown } from 'react-slidedown'
import Flip from 'react-reveal/Flip'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  DiversityEeoStatement,
  FundEngagementGradeBox,
  CompanyList,
  Chart,
  Grade,
  FundName,
  FundShareTakeAction,
  GetStartedInput,
  InlineSignup,
  IyvScorecard
} from '../../components'
import * as searchActions from 'redux/modules/search'

const Styles = require('./FundGenderScore.css')

const GROUP_LABELS_FIELDNAMES = [
  ['All funds','rank'],
  ['Groups','group'],
  // ['Categories','peer']
]

const DEFAULT_GROUP_TYPE = 'group'

@connect(
  state => ({
    result: state.shareClass.result,
    loading: state.shareClass.loading,
    loaded: state.shareClass.loaded,
    error: state.shareClass.error,
    cart: state.cart.result,
  }),
  searchActions)

@asyncConnect([{
  // need 'deferred' otherwise client navigate is blocked until page is loaded
  deferred: true,
  promise: ({params, store: {dispatch, getState}}) => {
    return dispatch(
      searchActions.shareClassDetails(
        params.fundId,
        params.investmentVehicleId
      )
    )
  }
}])
  
@CSSModules(Styles, {allowMultiple:true})
export default class FundGenderScore extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.object,
    cart: PropTypes.object
  }
  static contextTypes =  {
    router: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    // init state has all slidedown flags false, and grouping at default
    // grouping state is not stored in redux, resets for each fund visit
    this.state = {
      viewStats: false,
      showCriteriaSubscoreA: false,
      showCriteriaSubscoreB: false,
      showCriteriaSubscoreC: false,
      showCriteriaSubscoreD: false,
      viewSubscoreRanks: false,
      activeGrouping: DEFAULT_GROUP_TYPE,
      groupsLoaded: true,
      loadingTime: 500
    }
  }

  /**
   * Scroll to top before page loads (prevents loading page scrolled down due
   * to SPA routing weirdness)
   */
  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  /**
   * Trigger analytics event on page load
   */
  componentDidMount() {
    const { fundId, investmentVehicleId } = this.props.params
    analytics.event(analytics.eventLoadFund(fundId, investmentVehicleId))
  }

  /**
   * Update state with new flag for whether the 'view more' panel is shown
   */
  clickViewStats = () =>{
    this.setState({viewStats: !this.state.viewStats})
  }

  clickToggleCriteria = (subscoreId) =>{
    const showCriteriaField = 'showCriteriaSubscore' + subscoreId
    const newState = {}
    const subscoreIds = ['A', 'B', 'C', 'D']
    subscoreIds.forEach((el) => {
      if (el === subscoreId) {
        newState[showCriteriaField] = !this.state[showCriteriaField]
      } else {
        newState['showCriteriaSubscore' + el] = false
      }
    })
    this.setState(newState)
  }

  /**
   * Update state with new active grouping, to be used in displaying
   * percentile ranks and color sliders, and controlled by a form control.
   * Changing form control calls changeActiveGrouping() with the newly
   * selected grouping. Before updating grouping, a timeout is applied, to let
   * Flip component animations complete.
   *
   * @param  {String} newGrouping - Either 'rank', 'peer', or 'group'
   */
  changeActiveGrouping = (newGrouping) =>{
    if (
      (typeof newGrouping === 'string') &&
        (newGrouping !== this.state.activeGrouping) &&
          (newGrouping==='rank' ||
           newGrouping==='peer' ||
           newGrouping==='group')) {
      this.setState({
        groupsLoaded: false
      })

      // for loading animation
      setTimeout(() => {
        this.setState({
          activeGrouping: newGrouping,
          groupsLoaded: true
        })
      }, this.state.loadingTime)
    }
  }

  /**
   * Scroll to an element on the page. Need this solution since asyncConnect
   * and anchor links do not play nice. (However we have no anchor links at
   * the moment.) This is called when the page is initially mounting.
   *
   * @param  {String} id - element id to scroll to with offset
   *
   */
  scrollTo = (id) =>{
    return () =>{
      const ele = document.getElementById(id)
      window.scrollTo(ele.offsetLeft,ele.offsetTop)
    }
  }

  /**
   * DEPRECATED
   */
  // scrollToDomRef = () => {
  //   const myDomNode = ReactDOM.findDOMNode(this.balanceRef)
  //   myDomNode.scrollIntoView()
  // }

  /**
   * Close open tooltips programatically when a new one opens. Used for
   * clickable tooltips that remain open without hover. Tooltip refs are
   * listed here, any unlisted tooltips will not be closed.
   *
   * @param  {String} thisRef - string ref for tooltip that should be
   * programatically closed
   */
  closeAllTooltipsExcept = (thisRef) => {
    const allRefs = [
      // overall
      'refScoreContainer',
      'refRankContainer',
      'refPeerContainer',
      'refGroupContainer',
      // A
      'refSubscoreAScoreContainer',
      'refSubscoreARankContainer',
      'refSubscoreAGroupContainer',
      'refSubscoreAPeerContainer',
      // B
      'refSubscoreBScoreContainer',
      'refSubscoreBRankContainer',
      'refSubscoreBGroupContainer',
      'refSubscoreBPeerContainer',
      // C
      'refSubscoreCScoreContainer',
      'refSubscoreCRankContainer',
      'refSubscoreCGroupContainer',
      'refSubscoreCPeerContainer',
      // D
      'refSubscoreDScoreContainer',
      'refSubscoreDRankContainer',
      'refSubscoreDGroupContainer',
      'refSubscoreDPeerContainer'
    ]
    allRefs.map((ref) => {
      if (ref !== thisRef) {
        const _el = ReactDOM.findDOMNode(this[ref])
        if (_el) {
          ReactTooltip.hide(_el)
        }
      }
      return true
    })
  }

  /**
   * Generate HTML for complex tooltips
   *
   * @param  {String} type - the type of tooltip requested
   * @param  {Object} gefScoresState - the score state object with required
   * values, like scores, normalizers, and labels
   * @return {String} String of HTML to be rendered as a tooltip
   */
  generateTooltip = (type, gefScoresState = {}) => {
    // Using score state, we will build the HTML content inside this div
    // Some types of tooltips have different content if unranked/unscored

    const pluralizedHolding = format.maybePluralize(
      this.props.result.fund.gef_count,
      'holding'
    )

    /*
    * OVERALL SCORES AND RANKS
    */
    const overallScoreUnscored = `
      Equileap assigns a gender equality score to nearly 3,500 companies,
      based on four sub-scores: gender balance in leadership and workforce;
      equal compensation and work life balance; policies promoting gender
      equality; and commitment, transparency, and accountability. For each
      holding in a fund's portfolio that has been scored by Equileap, we use
      the company gender equality scores to calculate a score for the mutual
      fund. This fund is unscored, because none of the holdings are scored by
      Equileap.
    `

    const overallScore = `
      Equileap analyzes nearly 3,500 companies and assigns a <i>gender
      equality score</i> between 0 and 100. These overall scores are based on
      four sub-scores:
      <ul>
        <li>
          Gender balance in leadership and workforce (40 possible points)
        </li>
        <li>
          Equal compensation and work life balance (30 possible points)
        </li>
        <li>
          Policies promoting gender equality (20 possible points)
        </li>
        <li>
          Commitment, transparency, and accountability (10 possible points)
        </li>
      </ul>
      Using this data, we calculate an overall gender equality score for each
      mutual fund by:
      <ul>
        <li>
          taking each stock in the portfolio that's been scored by Equileap
        </li>
        <li>
          averaging those scores, weighted by market value
        </li>
      </ul>
      This fund
      had ${gefScoresState.gefCount} scored ${pluralizedHolding} with a
      weighted average <i>gender equality
      score</i> of ${gefScoresState.gefUnnormalizedOverallScore} out of 100.
    `

    const overallRankUnscored = `
      None of this fund's holdings were scored by Equileap. We couldn't
      calculate any gender equality scores for this fund, and the fund was not
      included in our rankings or assigned a grade.
    `
    const unrankedTooltip = `
      Less than 1/3 of this fund's long holdings were scored by Equileap. When
      the score coverage is below 33%, we remove the fund from our rankings to
      increase accuracy.
    `

    const overallRank = `
      Each fund's overall score is ranked against other U.S.-domiciled
      stock-based mutual funds.
      <ul style="padding-inline-start: 10px;">
        <li>
          This fund's score of ${gefScoresState.gefOverallScore} points
          ranked ${gefScoresState.gefOverallRank} out
          of ${gefScoresState.normAllScored} scored funds
        </li>
        <li>
          ${gefScoresState.gefOverallPercentileRank}% of all funds analyzed
          scored the same or lower
        </li>
      </ul>
    `

    const peerRank = `
      Each fund's overall score is ranked against other funds in the same
      category.
      <ul style="padding-inline-start: 10px;">
        <li>
          This fund's score of ${gefScoresState.gefOverallScore} points
          ranked ${gefScoresState.gefOverallPeerRank} out
          of ${gefScoresState.normPeer} for
          the <i>${gefScoresState.morningstar_category_name}</i> category
        </li>
        <li>
          ${gefScoresState.gefOverallPeerPercentileRank}% of other funds in
          the <i>${gefScoresState.morningstar_category_name}</i> category
          scored the same or lower
        </li>
      </ul>
    `

    const groupRank = `
      Each fund's overall score is ranked against other funds in the same
      group of categories.
      <ul style="padding-inline-start: 10px;">
        <li>
          This fund's score of ${gefScoresState.gefOverallScore} points
          ranked ${gefScoresState.gefOverallGroupRank} out
          of ${gefScoresState.normGroup} for
          the <i>${gefScoresState.category_group}</i> group
        </li>
        <li>
          ${gefScoresState.gefOverallGroupPercentileRank}% of other funds in
          the <i>${gefScoresState.category_group}</i> group scored the same or
          lower
        </li>
        <li>
          For a group percentile ranking
          of ${gefScoresState.gefOverallGroupPercentileRank}, this fund earns
          a grade of ${gefScoresState.gefOverallGroupGrade}
        </li>
      </ul>
    `

    /*
    * BALANCE/POLICIES SCORES
    */
    const subscoreAUnscored = `
      Equileap assigns companies a <i>gender balance in leadership and
      workforce score</i> between 0 and 40. We calculate a sub-score for each
      fund by:
      <ul style="padding-inline-start: 10px;">
        <li>
          taking each stock in the portfolio that's been scored by Equileap
        </li>
        <li>
          averaging the scores, weighted by market value
        </li>
      </ul>
      This fund is unscored, because none of the holdings are scored by
      Equileap.
    `

    const subscoreAScore = `
      Equileap assigns companies a <i>gender balance in leadership and
      workforce score</i> between 0 and 40. We calculate a sub-score for each
      fund by:
      <ul style="padding-inline-start: 10px;">
        <li>
          taking each stock in the portfolio that's been scored by Equileap
        </li>
        <li>
          averaging the scores, weighted by market value
        </li>
      </ul>
      This fund
      had ${gefScoresState.gefCount} scored ${pluralizedHolding} with a
      weighted average <i>gender balance in leadership and workforce
      score</i> of ${gefScoresState.subscoreAScoreUnnormalized} out of 40,
      rounded to ${gefScoresState.subscoreAScore} points.
    `

    const subscoreBUnscored = `
      Equileap assigns companies an <i>equal compensation and work life
      balance score</i> between 0 and 30. We calculate a sub-score for each
      fund by:
      <ul style="padding-inline-start: 10px;">
        <li>
          taking each stock in the portfolio that's been scored by Equileap
        </li>
        <li>
          averaging the scores, weighted by market value
        </li>
      </ul>
      This fund is unscored, because none of the holdings are scored by
      Equileap.
    `

    const subscoreBScore = `
      Equileap assigns companies an <i>equal compensation and work life
      balance score</i> between 0 and 30. We calculate a sub-score for each
      fund by:
      <ul style="padding-inline-start: 10px;">
        <li>
          taking each stock in the portfolio that's been scored by Equileap
        </li>
        <li>
          averaging the scores, weighted by market value
        </li>
      </ul>
      This fund
      had ${gefScoresState.gefCount} scored ${pluralizedHolding} with a
      weighted average <i>equal compensation and work life balance
      score</i> of ${gefScoresState.subscoreBScoreUnnormalized} out
      of 30, rounded to ${gefScoresState.subscoreBScore} points.
    `

    const subscoreCUnscored = `
      Equileap assigns companies a <i>policies promoting gender equality
      score</i> between 0 and 20. We calculate a sub-score for each
      fund by:
      <ul style="padding-inline-start: 10px;">
        <li>
          taking each stock in the portfolio that's been scored by Equileap
        </li>
        <li>
          averaging the scores, weighted by market value
        </li>
      </ul>
      This fund is unscored, because none of the holdings are scored by
      Equileap.
    `

    const subscoreCScore = `
      Equileap assigns companies a <i>policies promoting gender equality
      score</i> between 0 and 20. We calculate a sub-score for each
      fund by:
      <ul style="padding-inline-start: 10px;">
        <li>
          taking each stock in the portfolio that's been scored by Equileap
        </li>
        <li>
          averaging the scores, weighted by market value
        </li>
      </ul>
      This fund
      had ${gefScoresState.gefCount} scored ${pluralizedHolding} with a
      weighted average <i>policies promoting gender equality
      score</i> of ${gefScoresState.subscoreCScoreUnnormalized} out
      of 20, rounded to ${gefScoresState.subscoreCScore} points.
    `

    const subscoreDUnscored = `
      Equileap assigns companies a <i>commitment, transparency, and
      accountability score</i> between 0 and 10. We calculate a sub-score for
      each fund by:
      <ul style="padding-inline-start: 10px;">
        <li>
          taking each stock in the portfolio that's been scored by Equileap
        </li>
        <li>
          averaging the scores, weighted by market value
        </li>
      </ul>
      This fund is unscored, because none of the holdings are scored by
      Equileap.
    `

    const subscoreDScore = `
      Equileap assigns companies a <i>commitment, transparency, and
      accountability score</i> between 0 and 10. We calculate a sub-score for
      each fund by:
      <ul style="padding-inline-start: 10px;">
        <li>
          taking each stock in the portfolio that's been scored by Equileap
        </li>
        <li>
          averaging the scores, weighted by market value
        </li>
      </ul>
      This fund
      had ${gefScoresState.gefCount} scored ${pluralizedHolding} with a
      weighted average <i>commitment, transparency, and accountability
      score</i> of ${gefScoresState.subscoreDScoreUnnormalized} out
      of 10, rounded to ${gefScoresState.subscoreDScore} points.
    `

    /*
    * BALANCE/POLICIES RANKS
    */
    // A
    let subscoreARank = unrankedTooltip
    let subscoreAGroup = unrankedTooltip
    let subscoreAPeer = unrankedTooltip
    let subscoreBRank = unrankedTooltip
    let subscoreBGroup = unrankedTooltip
    let subscoreBPeer = unrankedTooltip
    let subscoreCRank = unrankedTooltip
    let subscoreCGroup = unrankedTooltip
    let subscoreCPeer = unrankedTooltip
    let subscoreDRank = unrankedTooltip
    let subscoreDGroup = unrankedTooltip
    let subscoreDPeer = unrankedTooltip
    if (!gefScoresState.isUnranked) {
      subscoreARank = `
        Each fund's gender balance in leadership and workforce score is ranked
        against other U.S. stock-based mutual funds.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's gender balance in leadership and workforce score
            of ${gefScoresState.subscoreAScore} points
            ranked ${gefScoresState.subscoreARank} out
            of ${gefScoresState.normAllScored} scored funds
          </li>
          <li>
            ${gefScoresState.subscoreAPercentileRank}% of all funds analyzed
            scored the same or lower
          </li>
        </ul>
      `
      subscoreAGroup = `
        Each fund's gender balance in leadership and workforce score is ranked
        against other funds in the same group of categories.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's gender balance in leadership and workforce score
            of ${gefScoresState.subscoreAScore} points
            ranked ${gefScoresState.subscoreAGroupRank} out
            of ${gefScoresState.normGroup} for
            the <i>${gefScoresState.category_group}</i> group
          </li>
          <li>
            ${gefScoresState.subscoreAGroupPercentileRank}% of other funds in
            the <i>${gefScoresState.category_group}</i> group scored the same
            or lower
          </li>
        </ul>
      `
      subscoreAPeer = `
        Each fund's gender balance in leadership and workforce score is ranked
        against other funds in the same category.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's gender balance in leadership and workforce score
            of ${gefScoresState.subscoreAScore} points
            ranked ${gefScoresState.subscoreAPeerRank} out
            of ${gefScoresState.normPeer} for
            the <i>${gefScoresState.morningstar_category_name}</i> category
          </li>
          <li>
            ${gefScoresState.subscoreAPeerPercentileRank}% of other funds in
            the <i>${gefScoresState.morningstar_category_name}</i> category
            scored the same or lower
          </li>
        </ul>
      `

      // B
      subscoreBRank = `
        Each fund's equal compensation and work life balance score is ranked
        against other U.S. stock-based mutual funds.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's equal compensation and work life balance score
            of ${gefScoresState.subscoreBScore} points
            ranked ${gefScoresState.subscoreBRank} out
            of ${gefScoresState.normAllScored} scored funds
          </li>
          <li>
            ${gefScoresState.subscoreBPercentileRank}% of all funds analyzed
            scored the same or lower
          </li>
        </ul>
      `
      subscoreBGroup = `
        Each fund's equal compensation and work life balance score is ranked
        against other funds in the same group of categories.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's equal compensation and work life balance score
            of ${gefScoresState.subscoreBScore} points
            ranked ${gefScoresState.subscoreBGroupRank} out
            of ${gefScoresState.normGroup} for
            the <i>${gefScoresState.category_group}</i> group
          </li>
          <li>
            ${gefScoresState.subscoreBGroupPercentileRank}% of other funds in
            the <i>${gefScoresState.category_group}</i> group scored the same
            or lower
          </li>
        </ul>
      `
      subscoreBPeer = `
        Each fund's equal compensation and work life balance score is ranked
        against other funds in the same category.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's equal compensation and work life balance score
            of ${gefScoresState.subscoreBScore} points
            ranked ${gefScoresState.subscoreBPeerRank} out
            of ${gefScoresState.normPeer} for
            the <i>${gefScoresState.morningstar_category_name}</i> category
          </li>
          <li>
            ${gefScoresState.subscoreBPeerPercentileRank}% of other funds in
            the <i>${gefScoresState.morningstar_category_name}</i> category
            scored the same or lower
          </li>
        </ul>
      `

      // C
      subscoreCRank = `
        Each fund's policies promoting gender equality score is ranked against
        other U.S. stock-based mutual funds.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's policies promoting gender equality score
            of ${gefScoresState.subscoreCScore} points
            ranked ${gefScoresState.subscoreCRank} out
            of ${gefScoresState.normAllScored} scored funds
          </li>
          <li>
            ${gefScoresState.subscoreCPercentileRank}% of all funds analyzed
            scored the same or lower
          </li>
        </ul>
      `
      subscoreCGroup = `
        Each fund's policies promoting gender equality score is ranked against
        other funds in the same group of categories.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's policies promoting gender equality score
            of ${gefScoresState.subscoreCScore} points
            ranked ${gefScoresState.subscoreCGroupRank} out
            of ${gefScoresState.normGroup} for
            the <i>${gefScoresState.category_group}</i> group
          </li>
          <li>
            ${gefScoresState.subscoreCGroupPercentileRank}% of other funds in
            the <i>${gefScoresState.category_group}</i> group scored the same
            or lower
          </li>
        </ul>
      `
      subscoreCPeer = `
        Each fund's policies promoting gender equality score is ranked against
        other funds in the same category.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's policies promoting gender equality score
            of ${gefScoresState.subscoreCScore} points
            ranked ${gefScoresState.subscoreCPeerRank} out
            of ${gefScoresState.normPeer} for
            the <i>${gefScoresState.morningstar_category_name}</i> category
          </li>
          <li>
            ${gefScoresState.subscoreCPeerPercentileRank}% of other funds in
            the <i>${gefScoresState.morningstar_category_name}</i> category
            scored the same or lower
          </li>
        </ul>
      `

      // D
      subscoreDRank = `
        Each fund's commitment, transparency, and accountability score is
        ranked against other U.S. stock-based mutual funds.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's commitment, transparency, and accountability score
            of ${gefScoresState.subscoreDScore} points
            ranked ${gefScoresState.subscoreDRank} out
            of ${gefScoresState.normAllScored} scored funds
          </li>
          <li>
            ${gefScoresState.subscoreCPercentileRank}% of all funds analyzed
            scored the same or lower
          </li>
        </ul>
      `
      subscoreDGroup = `
        Each fund's commitment, transparency, and accountability score is
        ranked against other funds in the same group of categories.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's commitment, transparency, and accountability score
            of ${gefScoresState.subscoreDScore} points
            ranked ${gefScoresState.subscoreDGroupRank} out
            of ${gefScoresState.normGroup} for
            the <i>${gefScoresState.category_group}</i> group
          </li>
          <li>
            ${gefScoresState.subscoreDGroupPercentileRank}% of other funds in
            the <i>${gefScoresState.category_group}</i> group scored the same
            or lower
          </li>
        </ul>
      `
      subscoreDPeer = `
        Each fund's commitment, transparency, and accountability score is
        ranked against other funds in the same category.
        <ul style="padding-inline-start: 10px;">
          <li>
            This fund's commitment, transparency, and accountability score
            of ${gefScoresState.subscoreDScore} points
            ranked ${gefScoresState.subscoreDPeerRank} out
            of ${gefScoresState.normPeer} for
            the <i>${gefScoresState.morningstar_category_name}</i> category
          </li>
          <li>
            ${gefScoresState.subscoreDPeerPercentileRank}% of other funds in
            the <i>${gefScoresState.morningstar_category_name}</i> category
            scored the same or lower
          </li>
        </ul>
      `
    }

    let fin = ''

    // Switch tooltip content based on requested type of tooltip
    switch (type) {
      case 'overallScoreUnscored':
        fin = overallScoreUnscored
        break
      case 'overallScore':
        fin = overallScore
        break
      case 'overallRankUnscored':
        fin = overallRankUnscored
        break
      case 'overallRankUnranked':
        fin = unrankedTooltip
        break
      case 'overallRank':
        fin = overallRank
        break
      case 'peerRankUnscored':
        fin = overallRankUnscored
        break
      case 'peerRankUnranked':
        fin = unrankedTooltip
        break
      case 'peerRank':
        fin = peerRank
        break
      case 'groupRankUnscored':
        fin = overallRankUnscored
        break
      case 'groupRankUnranked':
        fin = unrankedTooltip
        break
      case 'groupRank':
        fin = groupRank
        break
      //
      //
      case 'subscoreAScoreUnscored':
        fin = subscoreAUnscored
        break
      case 'subscoreAScore':
        fin = subscoreAScore
        break
      case 'subscoreBScoreUnscored':
        fin = subscoreBUnscored
        break
      case 'subscoreBScore':
        fin = subscoreBScore
        break
      case 'subscoreCScoreUnscored':
        fin = subscoreCUnscored
        break
      case 'subscoreCScore':
        fin = subscoreCScore
        break
      case 'subscoreDScoreUnscored':
        fin = subscoreDUnscored
        break
      case 'subscoreDScore':
        fin = subscoreDScore
        break
      //
      //
      case 'subscoreARank':
        fin = subscoreARank
        break
      case 'subscoreAGroup':
        fin = subscoreAGroup
        break
      case 'subscoreAPeer':
        fin = subscoreAPeer
        break
      case 'subscoreBRank':
        fin = subscoreBRank
        break
      case 'subscoreBGroup':
        fin = subscoreBGroup
        break
      case 'subscoreBPeer':
        fin = subscoreBPeer
        break
      case 'subscoreCRank':
        fin = subscoreCRank
        break
      case 'subscoreCGroup':
        fin = subscoreCGroup
        break
      case 'subscoreCPeer':
        fin = subscoreCPeer
        break
      case 'subscoreDRank':
        fin = subscoreDRank
        break
      case 'subscoreDGroup':
        fin = subscoreDGroup
        break
      case 'subscoreDPeer':
        fin = subscoreDPeer
        break
      //
      //
      default:
        fin = "ERROR (shouldn't see this)"
        break
    }

    return format.tooltipHtml(fin)
  }

  /**
   * logic for data for subscore config
   * @param  {obj} gefScoresState results for fund
   * @return {obj}                config for subscore score containers
   */
  generateSubscoreConfig = (gefScoresState) => {
    //
    const { isUnscored } = gefScoresState

    // icons
    const subscoreAIcon = require(
      '../../../static/images/GEF-icons-gender-balance-peer-rank.svg'
    )
    const subscoreBIcon = require(
      '../../../static/images/GEF-icons-gender-equality-peer-rank.svg'
    )
    const subscoreCIcon = require(
      '../../../static/images/GEF-icons-gender-equality-policies-rank.svg'
    )
    const subscoreDIcon = require(
      '../../../static/images/GEF-icons-gender-equality-policies-score.svg'
    )

    // chart to show if fund is unscored
    const unscoredChart = (
      <div styleName='subscores-col-ban'>
        <LinkIcon nospace faclass='fa-ban'/>
        &nbsp;
        Unscored
      </div>
    )

    // function to generate a chart for a subscore
    const mainSubscoreChart = (value, normalizedValue, outOf) => {
      return  (
        <div styleName='subscores-col-score-figure'>
          {value}
          <span styleName='subscores-col-score-figure-out-of'>
            /{format.number(outOf * 100)}
          </span>
        </div>
        )
    }

    const subscoreConfig = {
      A: {
        chartValue: '-1',
        chartStyle: 'percentile-null',
        chartDisplay: unscoredChart,
        shortLabel: 'Gender balance in leadership and workforce',
        longLabel: 'Gender balance in leadership and workforce',
        icon: subscoreAIcon,
        tooltipRef: 'refSubscoreAScoreContainer',
        tooltipDataId: 'subscore-A-score-container',
        generateTooltipId: 'subscoreAScoreUnscored',
      },
      B: {
        chartValue: '-1',
        chartStyle: 'percentile-null',
        chartDisplay: unscoredChart,
        shortLabel: 'Equal compensation and work life balance',
        longLabel: 'Equal compensation and work life balance',
        icon: subscoreBIcon,
        tooltipRef: 'refSubscoreBScoreContainer',
        tooltipDataId: 'subscore-B-score-container',
        generateTooltipId: 'subscoreBScoreUnscored',
      },
      C: {
        chartValue: '-1',
        chartStyle: 'percentile-null',
        chartDisplay: unscoredChart,
        shortLabel: 'Policies promoting gender equality',
        longLabel: 'Policies promoting gender equality',
        icon: subscoreCIcon,
        tooltipRef: 'refSubscoreCScoreContainer',
        tooltipDataId: 'subscore-C-score-container',
        generateTooltipId: 'subscoreCScoreUnscored',
      },
      D: {
        chartValue: '-1',
        chartStyle: 'percentile-null',
        chartDisplay: unscoredChart,
        shortLabel: 'Commitment, transparency, and accountability',
        longLabel: 'Commitment, transparency, and accountability',
        icon: subscoreDIcon,
        tooltipRef: 'refSubscoreDScoreContainer',
        tooltipDataId: 'subscore-D-score-container',
        generateTooltipId: 'subscoreDScoreUnscored',
      }
    }

    const outOfs = {
      A: 0.4,
      B: 0.3,
      C: 0.2,
      D: 0.1
    }

    if (!isUnscored) {
      // subscore A
      const normalizedSubscoreA = gefScoresState.subscoreAScore / outOfs.A
      subscoreConfig.A.generateTooltipId = 'subscoreAScore'
      subscoreConfig.A.chartValue = normalizedSubscoreA
      subscoreConfig.A.chartStyle = format.scoreStyle(normalizedSubscoreA)
      subscoreConfig.A.chartDisplay = mainSubscoreChart(
        gefScoresState.subscoreAScore, // value
        normalizedSubscoreA, // normalizedValue
        outOfs.A // outOf
      )

      // subscore B
      const normalizedSubscoreB = gefScoresState.subscoreBScore / outOfs.B
      subscoreConfig.B.generateTooltipId = 'subscoreBScore'
      subscoreConfig.B.chartValue = normalizedSubscoreB
      subscoreConfig.B.chartStyle = format.scoreStyle(normalizedSubscoreB)
      subscoreConfig.B.chartDisplay = mainSubscoreChart(
        gefScoresState.subscoreBScore, // value
        normalizedSubscoreB, // normalizedValue
        outOfs.B // outOf
      )

      // subscore C
      const normalizedSubscoreC = gefScoresState.subscoreCScore / outOfs.C
      subscoreConfig.C.generateTooltipId = 'subscoreCScore'
      subscoreConfig.C.chartValue = normalizedSubscoreC
      subscoreConfig.C.chartStyle = format.scoreStyle(normalizedSubscoreC)
      subscoreConfig.C.chartDisplay = mainSubscoreChart(
        gefScoresState.subscoreCScore, // value
        normalizedSubscoreC, // normalizedValue
        outOfs.C // outOf
      )

      // subscore D
      const normalizedSubscoreD = gefScoresState.subscoreDScore / outOfs.D
      subscoreConfig.D.generateTooltipId = 'subscoreDScore'
      subscoreConfig.D.chartValue = normalizedSubscoreD
      subscoreConfig.D.chartStyle = format.scoreStyle(normalizedSubscoreD)
      subscoreConfig.D.chartDisplay = mainSubscoreChart(
        gefScoresState.subscoreDScore, // value
        normalizedSubscoreD, // normalizedValue
        outOfs.D // outOf
      )
    }

    return subscoreConfig
    //
  }

  /**
   * Render form control to change active grouping. This form control
   * associates with the overall ranking container. Using some constants and
   * the current active grouping from state, a form control is rendered where
   * the current active grouping can be changed. This calls
   * changeActiveGrouping() and updates state, which rerenders ranking
   * containers and form controls using new active grouping.
   *
   * @param  {String} actvGrp - the label of the active grouping, taken from
   * state. Will be 'rank', 'peer', or 'group'
   * @return {JSX} container with clickable form control options, plus an
   * explanatory tooltip
   */
  renderGroupControl = (actvGrp) => {
    // Constants for groups are defined at top of file
    const params = GROUP_LABELS_FIELDNAMES

    return (
      <div styleName='active-group-control-wrap'>

        { /* Gear icon */ }
        <div styleName='active-group-control-lbl'>
          <LinkIcon faclass='fa-cog fa-2x' nospace/>
        </div>

        { /* For each grouping type, render a form control option
             If it's the active grouping, render different styling
             Attach state-update to onClick of form control options */ }
        <div styleName='active-group-control-opt-wrp'>
          {params.map((el,ix)=>{
            return (
              <div
                key={'grping_'+ix}
                styleName={
                  actvGrp !== el[1] ?
                    'active-group-control-opt' :
                    'active-group-control-opt-actv'
                }
                onClick={
                  () => { this.changeActiveGrouping(el[1]) }
                }
              >
                <span
                  styleName={
                    actvGrp !== el[1] ?
                      'crt-inv' :
                      'crt-vis'
                  }
                >
                  <LinkIcon faclass='fa-caret-right'/>
                </span>
                &nbsp;
                {el[0]}
                { /* (el[1]===DEFAULT_GROUP_TYPE) ? (
                  <span>
                    <br/>
                    <span styleName='crt-inv'>
                      <LinkIcon faclass='fa-caret-right' />
                    </span>
                    &nbsp;
                    <small><i>Suggested</i></small>
                  </span>
                ) : null */ }
              </div>
            )
          })}
        </div>

        { /* Explanatory tooltip */ }
        <div
          styleName='active-group-control-lbl'
          data-multiline
          data-effect='solid'
          data-tip={
            format.tooltipHtml(
              `
              Change the ranking:
              <ul style="padding-inline-start: 10px;">
                <li>
                  All funds, ranking <i>all scored U.S. stock-based mutual
                  funds and ETFs</i> against each other. This is the broadest
                  setting.
                </li>
                <li>
                  Groups, ranking funds against funds in the same group.
                  This is the default setting. The letter grade is based on
                  the group ranking.
                </li>
              </ul>
              `
            )
          }
          data-for='group-control-lbl'
          data-place='left'
          data-html
        >
          <LinkIcon faclass='fa-info-circle fa-2x' nospace/>
        </div>
        <ReactTooltip id='group-control-lbl'/>
      </div>
    )
  }

  /**
   * Renders a few descriptive sentences for the overall ranking container.
   * Explains the universe of funds chosen, and the specific ranking (with
   * normalizing group size) that underlies the percentile figure. Includes a
   * link to the List view that changes parameters based on active grouping.
   *
   * @param  {String} actGrp - the label of the active grouping, taken from
   * state. Will be 'rank', 'peer', or 'group'
   * @param  {String} nm - formatted normalizing figure for currently active
   * grouping
   * @param  {Object} scrSt - the score state object (for group labels)
   * @param  {Strinbg} lbl - The long label for the active group type. Will be
   * 'All funds', 'Groups', or 'Categories'.
   * @param  {[type]} actvRnk - formatted rank figure for currently active
   * grouping
   * @return {JSX} container with sentences and link defined by active group
   */
  renderRankDescription = (actGrp, nm, scrSt, lbl, actvRnk) => {
    // adjust URL based on active grouping, so we load funds from that group
    // on the list page
    let url = ''
    if (actGrp === 'rank') {
      url = config.routes.list
      return (
        <div styleName='overall-rank-description'>
          <div styleName='overall-rank-raw-score'>
            <i>Universe:</i> {lbl}
          </div>
          <br/>
          <div styleName='overall-rank-raw-score'>
            <br/>
          </div>
          <br/>
          <div styleName='overall-rank-raw-score'>
            <i>Ranking:</i> {actvRnk} out of {nm} funds
          </div>
          <br/>
          <br/>
          <Link xstrong to={url}>
            See more funds<LinkIcon />
          </Link>
        </div>
      )
    } else if (actGrp === 'group') {
      const gp = scrSt.category_group
      url = config.routes.list + '?grp=' + encodeURIComponent(gp)
      return (
        <div styleName='overall-rank-description'>
          <div styleName='overall-rank-raw-score'>
            <i>Universe:</i> {lbl}
          </div>
          <br/>
          <div styleName='overall-rank-raw-score'>
            <i>Group:</i> {gp}
          </div>
          <br/>
          <div styleName='overall-rank-raw-score'>
            <i>Ranking:</i> {actvRnk} out of {nm} funds
          </div>
          <br/>
          <br/>
          <Link xstrong to={url}>
            See more funds from this group<LinkIcon />
          </Link>
        </div>
      )
    } else if (actGrp === 'peer') {
      const ct = scrSt.morningstar_category_name
      url = config.routes.list + '?fdc=' + encodeURIComponent(ct)
      return (
        <div styleName='overall-rank-description'>
          <div styleName='overall-rank-raw-score'>
            <i>Universe:</i> {lbl}
          </div>
          <br/>
          <div styleName='overall-rank-raw-score'>
            <i>Category:</i> {ct}
          </div>
          <br/>
          <div styleName='overall-rank-raw-score'>
            <i>Ranking:</i> {actvRnk} out of {nm} funds
          </div>
          <br/>
          <br/>
          <Link xstrong to={url}>
            See more funds from this category<LinkIcon />
          </Link>
        </div>
      )
    }
  }

  /**
   * Render the first row of data containers: a pie chart for the overall
   * score, and a ranking container with a color slider and a form control to
   * adjust current active grouping. Each data container also has an alternate
   * if the fund is unscored or unranked.
   *
   * @param  {Object} shareClass - shareclass object
   * @param  {Object} fund - fund object
   * @param  {Object} gefScoresState - score state object
   * @return {JSX} row with data vizualizations and form controls
   */
  renderOverallScores = (shareClass, fund, gefScoresState) => {
    // load icons
    const overallScoreIcon = require(
      '../../../static/images/GEF-icons-gender-equality-score.svg'
      )
    const rankIcon = require('../../../static/images/GEF-icons-peer-rank.svg')

    // alias active grouping from state
    const actvGrp = this.state.activeGrouping

    // tooltip content if the fund is unranked
    const isUnrankedTooltip = format.tooltipHtml(
      `
        The percent of the fund's long-position holdings (including stocks,
        bonds, and other asset types, but excluding short positions) made up
        of stocks that are covered by the Equileap Company Gender Equality
        Score universe. Must be at least 33% for a fund to be included in our
        rankings and assigned a grade.
      `
    )

    // tooltip content if the fund is unranked and zero percent rated
    const isZeroPercentRatedTooltip = format.tooltipHtml(
      `
        None of this fund's holdings were scored by Equileap. We couldn't
        calculate any gender equality scores for this fund, and the fund was
        not included in our rankings or assigned a grade.
      `
    )

    // tooltip content if the fund is unranked, >0% rated
    const unrankedGtZeroPercentRatedTooltip = format.tooltipHtml(
      `
        Less than 1/3 of this fund's long holdings were scored by Equileap.
        We calculated gender equality scores for this fund based on
        the ${gefScoresState.gefPercentRated} of the fund holdings that had
        Equileap scores, but whenever the score coverage is below 1/3 (33%),
        we remove the fund from our rankings to increase accuracy.
      `
    )

    const activeGradeAsInt = format.gefGradeAsInt(
      gefScoresState.gefOverallGroupGrade
    )

    // setup empty variables for switch logic
    let label = ''
    let headlineLbl = ''
    let activeRank = null
    let activePrank = null
    let nrm = null
    let tooltipLbl = null

    // switch on active grouping ('rank', 'peer', or 'group')
    switch (actvGrp) {
      case 'rank':
        label = 'All funds'
        headlineLbl = 'Overall'
        activeRank = gefScoresState.gefOverallRank
        activePrank = gefScoresState.gefOverallPercentileRank
        nrm = gefScoresState.normAllScored
        tooltipLbl = 'overallRank'
        break
      case 'group':
        label = 'Groups'
        headlineLbl = 'Group'
        activeRank = gefScoresState.gefOverallGroupRank
        activePrank = gefScoresState.gefOverallGroupPercentileRank
        nrm = gefScoresState.normGroup
        tooltipLbl = 'groupRank'
        break
      // case 'peer':
      //   label = 'Categories'
      //   headlineLbl = 'Category'
      //   activeRank = gefScoresState.gefOverallPeerRank
      //   activePrank = gefScoresState.gefOverallPeerPercentileRank
      //   nrm = gefScoresState.normPeer
      //   tooltipLbl = 'peerRank'
      //   break
      default:
        headlineLbl = 'ERR'
        label = "ERROR (shouldn't see this)"
        break
    }

    let generateTooltipId = 'overallScoreUnscored'
    let overallScoreChart = (
      <Chart
        gefScore='-1'
        gefStyle='percentile-null'
        type='large'
      />
    )
    if (!gefScoresState.isUnscored) {
      generateTooltipId = 'overallScore'
      overallScoreChart = (
        <Chart
          gefScore={String(gefScoresState.gefOverallScore)}
          gefStyle={format.scoreStyle(gefScoresState.gefOverallScore)}
          type='large'
        />
      )
    }

    return (
      <div styleName='overall-wrap'>
        <div styleName='overall-container'>
          { /* OVERALL SCORE CONTAINER
               is this fund unscored?
               if the fund is unscored:
               render the unscored overall container */ }
          <div styleName='overall-score-container'>
            <div
              styleName='overall-score-container-inner'
              data-multiline
              data-effect='solid'
              data-place='bottom'
              // data-scroll-hide={false}
              data-for='score-container'
              data-html
              data-event='click focus'
              ref={(ref) => { this.refScoreContainer = ref }}
              data-tip={
                this.generateTooltip(
                  generateTooltipId,
                  gefScoresState
                )
              }
            >
              <div styleName='overall-score-title'>
                <div styleName='icon-label-wrap'>
                  <img
                    src={overallScoreIcon}
                    alt='Gender equality score'
                    styleName='inline-icon'
                  />
                  <div styleName='icon-label'>
                    Gender equality score
                  </div>
                </div>
              </div>
              <br/>
              <div styleName='overall-score-chart-wrap'>
                <div styleName='overall-score-chart'>
                  {overallScoreChart}
                </div>
                <div styleName='overall-score-text'>
                  <div styleName='overall-score-headline'>
                    Overall score
                  </div>
                  <div styleName='overall-score-description'>
                    Average Equileap Gender Equality Score of
                    fund holdings, weighted by market value
                  </div>
                </div>
              </div>
            </div>
            <ReactTooltip
              id='score-container'
              globalEventOff='click'
              afterShow={
                () => { this.closeAllTooltipsExcept('refScoreContainer') }
              }
            />
          </div>

          { /* OVERALL RANKING CONTAINER
               is this fund unranked?
               if the fund is unranked:
               render the unranked peer rank container */ }
          {
            gefScoresState.isUnranked ?
              (
                <div styleName='overall-peer-container'>
                  <div
                    styleName='overall-rank-container-inner'
                    data-multiline
                    data-effect='solid'
                    data-place='bottom'
                    data-for='peer-container'
                    data-html
                    data-event='click focus'
                    ref={(ref) => { this.refPeerContainer = ref }}
                    data-tip={
                      this.generateTooltip(
                        (
                          gefScoresState.gefPercentRated==='-100%' ?
                            'peerRankUnscored' :
                            'peerRankUnranked'
                        ),
                        gefScoresState
                      )
                    }
                  >
                    <div styleName='overall-rank-title'>
                      <div styleName='icon-label-wrap'>
                        <img
                          src={rankIcon}
                          alt='Peer rank'
                          styleName='inline-icon'
                        />
                        <div styleName='icon-label'>Group ranking</div>
                      </div>
                    </div>
                    <br/>
                    <div styleName='overall-rank-colorbar-wrap'>
                      <div styleName='overall-rank-colorbar-figure'>
                        <div styleName='overall-rank-colorbar-ban'>
                          <LinkIcon nospace faclass='fa-ban'/>
                        </div>
                        <div styleName='overall-rank-colorbar-label'>
                          Unranked
                        </div>
                      </div>
                    </div>
                    <br/>
                    <div>
                      Not ranked due to low data coverage
                    </div>
                    <br/>
                    <div styleName='col-right'>
                      <div styleName='stats-label'>
                        % Equileap coverage
                        <span
                          data-multiline
                          data-effect='solid'
                          data-place='bottom'
                          data-for='gef-percent-rated'
                          data-html
                          // data-event='click focus'
                          // data-scroll-hide={false}
                          data-tip={isUnrankedTooltip}
                        >
                          <LinkIcon faclass='fa-info-circle' />
                          <ReactTooltip id='gef-percent-rated' />
                        </span>
                      </div>
                      <div styleName='stats-value'>
                        { /* display either the low percent rated, or 0%  */
                          gefScoresState.gefPercentRated==='-100%' ?
                            '0%' :
                            gefScoresState.gefPercentRated
                        }
                        { /* if rank is -1, the percent rated was too low */
                          format.number(fund.gef_rank) === '-1' ?
                            (
                              <span
                                data-multiline
                                data-effect='solid'
                                data-place='bottom'
                                data-for='low-percent-rated'
                                data-html
                                // data-event='click focus'
                                ref={(ref) => { this.refLowPercentRated = ref }}
                                data-tip={
                                  gefScoresState.gefPercentRated==='-100%' ?
                                    isZeroPercentRatedTooltip :
                                    unrankedGtZeroPercentRatedTooltip
                                }
                              >
                                <LinkIcon
                                  faclass='fa-exclamation-triangle fa-2x'
                                />
                                <ReactTooltip id='low-percent-rated'/>
                              </span>
                            ) :
                            null
                        }
                      </div>
                    </div>
                  </div>
                  <ReactTooltip
                    id='peer-container'
                    globalEventOff='click'
                    afterShow={
                      () => { this.closeAllTooltipsExcept('refPeerContainer') }
                    }
                  />
                </div>
              ) :
              /* if the fund is ranked: render the peer rank container */
              (
                <div styleName='overall-peer-container'>
                  <Flip top opposite when={this.state.groupsLoaded}>
                    <div
                      styleName='overall-rank-container-inner'
                      data-multiline
                      data-effect='solid'
                      data-place='bottom'
                      data-for='peer-container'
                      data-html
                      data-event='click focus'
                      ref={(ref) => { this.refPeerContainer = ref }}
                      data-tip={
                        this.generateTooltip(tooltipLbl, gefScoresState)
                      }
                    >
                      <div styleName='overall-rank-title'>
                        <div styleName='icon-label-wrap'>
                          <img
                            src={rankIcon}
                            alt='Peer rank'
                            styleName='inline-icon'
                          />
                          <div styleName='icon-label'>
                            {headlineLbl} ranking
                          </div>
                        </div>
                      </div>
                      <br/>
                      <div styleName='overall-rank-colorbar-grade-wrap'>
                        {
                          this.state.activeGrouping==='group' ?
                            (
                              <div styleName='reportcard-result-grade'>
                                <Grade grade={fund.grade_gender_equality} large />
                              </div>
                            ) :
                            null
                        }
                        <div styleName='overall-rank-colorbar-wrap'>
                          <div
                            styleName={
                              'overall-rank-colorbar ' +
                                format.scoreStyle(activePrank)
                            }
                          />
                          <div styleName='overall-rank-colorbar-figure'>
                            <div styleName='overall-rank-colorbar-score'>
                              {activePrank}
                            </div>
                            <div styleName='overall-rank-colorbar-label'>
                              percentile
                            </div>
                          </div>
                        </div>
                      </div>
                      <br/>
                      { /* render the rank description */
                        this.renderRankDescription(
                          actvGrp,
                          nrm,
                          fund,
                          label,
                          activeRank
                        )
                      }
                    </div>
                  </Flip>
                  <ReactTooltip
                    id='peer-container'
                    globalEventOff='click'
                    afterShow={
                      () => { this.closeAllTooltipsExcept('refPeerContainer') }
                    }
                  />
                </div>
              )
          }
          { /* FORM CONTROL FOR GROUPING */ }
          {
            !gefScoresState.isUnranked ?
              this.renderGroupControl(actvGrp) :
              null
          }
        </div>
      </div>
    )
  }

  /**
   * Render sub-score container.
   */
  renderSubscoreScore = (subscoreId, subscoreConfig, gefScoresState) => {
    //
    const cnfg = subscoreConfig[subscoreId]

    return (
      <Col styleName='subscores-col' md={3} sm={6} xs={12}>
        <div
          styleName='subscores-col-inner'
          data-multiline
          data-effect='solid'
          data-place='bottom'
          data-for={cnfg.tooltipDataId}
          data-html
          data-event='click focus'
          ref={(ref) => { this[cnfg.tooltipRef] = ref }}
          data-tip={
            this.generateTooltip(
              cnfg.generateTooltipId,
              gefScoresState
            )
          }
        >
          <div styleName='subscores-col-title-wrap'>
            <img
              src={cnfg.icon}
              alt={cnfg.shortLabel}
              styleName='inline-icon-sm'
            />
            <div styleName='subscores-col-title'>
              {cnfg.shortLabel}
            </div>
          </div>
          <div styleName='subscores-col-chart-wrap'>
            <Chart
              gefScore={String(cnfg.chartValue)}
              gefStyle={cnfg.chartStyle}
              type='small'
            />
            {cnfg.chartDisplay}
          </div>
        </div>
        <div
          styleName='subscores-col-methodology-button'
          onClick={
            () => {
              this.clickToggleCriteria(subscoreId)
            }
          }
        >
          See the score criteria
          <LinkIcon
            faclass={
              this.state['showCriteriaSubscore' + subscoreId] ?
                'fa-angle-up':
                'fa-angle-down'
            }
          />
        </div>
        { /* on sm screens, subscore methodolgies appear right below */ }
        <div styleName='visible-xs'>
          <SlideDown>
            {
              this.state.showCriteriaSubscoreA && subscoreId === 'A' ?
                this.renderSubscoreMethodology('A') :
                null
            }
          </SlideDown>
          <SlideDown>
            {
              this.state.showCriteriaSubscoreB && subscoreId === 'B' ?
                this.renderSubscoreMethodology('B') :
                null
            }
          </SlideDown>
          <SlideDown>
            {
              this.state.showCriteriaSubscoreC && subscoreId === 'C' ?
                this.renderSubscoreMethodology('C') :
                null
            }
          </SlideDown>
          <SlideDown>
            {
              this.state.showCriteriaSubscoreD && subscoreId === 'D' ?
                this.renderSubscoreMethodology('D') :
                null
            }
          </SlideDown>
        </div>
        <ReactTooltip
          id={cnfg.tooltipDataId}
          globalEventOff='click'
          afterShow={
            () => { this.closeAllTooltipsExcept(cnfg.tooltipRef) }
          }
        />
      </Col>
    )
  }

  /**
   * Render sub-score containers.
   *
   * @param  {Object} shareClass - shareclass object
   * @param  {Object} fund - fund object
   * @param  {Object} gefScoresState - score state object
   * @return {JSX} Grid of data visualizations and Slidedowns
   */
  renderSubscoreScores = (shareClass, fund, gefScoresState) => {
    //
    const subscoreConfig = this.generateSubscoreConfig(gefScoresState)
    //
    return (
      <div>
        <div styleName='subscores-wrap'>
          <Row styleName='subscores-row'>
            {this.renderSubscoreScore('A', subscoreConfig, gefScoresState)}
            {this.renderSubscoreScore('B', subscoreConfig, gefScoresState)}
            {this.renderSubscoreScore('C', subscoreConfig, gefScoresState)}
            {this.renderSubscoreScore('D', subscoreConfig, gefScoresState)}
          </Row>
        </div>
        <div styleName='hidden-xs'>
          <SlideDown>
            {
              this.state.showCriteriaSubscoreA ?
                this.renderSubscoreMethodology('A') :
                null
            }
          </SlideDown>
          <SlideDown>
            {
              this.state.showCriteriaSubscoreB ?
                this.renderSubscoreMethodology('B') :
                null
            }
          </SlideDown>
          <SlideDown>
            {
              this.state.showCriteriaSubscoreC ?
                this.renderSubscoreMethodology('C') :
                null
            }
          </SlideDown>
          <SlideDown>
            {
              this.state.showCriteriaSubscoreD ?
                this.renderSubscoreMethodology('D') :
                null
            }
          </SlideDown>
        </div>
      </div>
    )
  }

  /**
   * Render function for static content, balance methodology bullet points.
   * Slidedown displayed/hidden by state.showSubscoreACriteria
   *
   * @return {JSX} Slidedown container
   */
  renderSubscoreMethodology = (subscoreId) => {
    // subscore A
    if (subscoreId === 'A') {
      return (
        <div styleName='score-criteria'>
          <div styleName='score-criteria-title'>
            Score criteria: Gender balance in leadership and workforce
          </div>
          <p>
            Companies can earn up to 40 points for the gender balance in
            leadership and workforce category.
          </p>
          <ol>
            <li>
              <strong>Board of Directors</strong> - Percentage of male and
              female Board of Directors as a proportion of the total number.
              Where the company has a Supervisory Board and a Management
              Board, this refers to the Supervisory Board.
            </li>
            <li>
              <strong>Executives</strong> - Percentage of male and female
              Executives as a percentage of the total number. Executives are
              as defined by the company or represent those individuals that
              form the company Executive Committee/Board or Management
              Committee/Board or equivalent.
            </li>
            <li>
              <strong>Senior Management</strong> - Percentage of male and
              female senior managers as a percentage of total. Senior
              Management are defined and reported by the company.
            </li>
            <li>
              <strong>Workforce</strong> - Ratio of each gender in Senior
              Management compared to ratio of each gender in the Workforce.
            </li>
            <li>
              <strong>Promotion and Career Development
              Opportunities</strong> - Ratio of each gender in senior
              management compared to ratio of each gender in the
              workforce
            </li>
          </ol>
          <p>
            <Link
              to={config.routes.howitworks}
              alt='How it works | Gender Equality Funds'
              xstrong
            >
              See the full Gender Equality Funds methodology<LinkIcon/>
            </Link>
          </p>
        </div>
      )
    }
    // subscore B
    if (subscoreId === 'B') {
      return (
        <div styleName='score-criteria'>
          <div styleName='score-criteria-title'>
            Score criteria: Equal compensation and work life balance
          </div>
          <p>
            Companies can earn up to 30 points for the equal compensation and
            work life balance category.
          </p>
          <ol>
            <li>
              <strong>Living Wage</strong> - Commitment to ensure payment of a
              living wage to all employees, even in those countries that do
              not legally require a minimum wage or where minimum wage is not
              a living wage.
            </li>
            <li>
              <strong>Gender Pay Gap</strong> - Commitment to provide
              comparable wages for comparable work and to close the gender pay
              gap.
            </li>
            <li>
              <strong>Parental Leave</strong> - Paid leave programs (at least
                2/3 paid) for child care to both primary or secondary carers
              globally or at least in the country of incorporation.
            </li>
            <li>
              <strong>Flexible Work Options</strong> - Option for employees to
              control and/or vary the start and end times of the work day
              and/or vary the location from which employees work.
            </li>
          </ol>
          <p>
            <Link
              to={config.routes.howitworks}
              alt='How it works | Gender Equality Funds'
              xstrong
            >
              See the full Gender Equality Funds methodology<LinkIcon/>
            </Link>
          </p>
        </div>
      )
    }
    // subscore C
    if (subscoreId === 'C') {
      return (
        <div styleName='score-criteria'>
          <div styleName='score-criteria-title'>
            Score criteria: Policies promoting gender equality
          </div>
          <p>
            Companies can earn up to 20 points for the policies promoting
            gender equality category.
          </p>
          <ol>
            <li>
              <strong>Training and Career Development</strong> - Commitment to
              ensure equal access to training and career development to both
              men and women.
            </li>
            <li>
              <strong>Recruitment Strategy</strong> - Commitment to ensure
              non-discrimination against any type of demographic group and
              equal opportunities to ensure gender parity.
            </li>
            <li>
              <strong>Freedom from Violence, Abuse, and Sexual
              Harassment</strong> - Prohibits all forms of violence in the
              work place, including verbal, physical and sexual harassment.
            </li>
            <li>
              <strong>Safety at Work</strong> - Commitment to the safety of
              employees in the workplace, in travel to and from the workplace,
              and on company related business, and ensure the safety of
              vendors in the workplace.
            </li>
            <li>
              <strong>Human Rights</strong> - Commitment to ensure the
              protection of the rights of all people it works with including
              employees’ rights to participate in legal, civic and political
              affairs.
            </li>
            <li>
              <strong>Social Supply Chain</strong> - Commitment to reduce
              social risks in its supply chain such as forbid business related
              activities that condone, support, or otherwise participate in
              trafficking, including for labour or sexual exploitation.
            </li>
            <li>
              <strong>Supplier Diversity</strong> - Commitment to ensure
              diversity in the supply chain, including support for women owned
              businesses in the supply chain.
            </li>
            <li>
              <strong>Employee Protection</strong> - Systems and policies for
              the reporting of internal ethical compliance complaints without
              retaliation or retribution, including but not limited to access
              to confidential third-party ethics hotlines or systems for
              confidential written complaints.
            </li>
          </ol>
          <p>
            <Link
              to={config.routes.howitworks}
              alt='How it works | Gender Equality Funds'
              xstrong
            >
              See the full Gender Equality Funds methodology<LinkIcon/>
            </Link>
          </p>
        </div>
      )
    }
    // subscore D
    if (subscoreId === 'D') {
      return (
        <div styleName='score-criteria'>
          <div styleName='score-criteria-title'>
            Score criteria: Commitment, transparency, and accountability
          </div>
          <p>
            Companies can earn up to 10 points for the commitment,
            transparency, and accountability category.
          </p>
          <ol>
            <li>
              <strong>Commitment to Women's Empowerment</strong> - Recognition
              and commitment to ensuring women’s empowerment in the workplace.
            </li>
            <li>
              <strong>Audit</strong> - Undertaken and awarded an independent
              gender audit certificate by an Equileap recognized body.
            </li>
          </ol>
          <p>
            <Link
              to={config.routes.howitworks}
              alt='How it works | Gender Equality Funds'
              xstrong
            >
              See the full Gender Equality Funds methodology<LinkIcon/>
            </Link>
          </p>
        </div>
      )
    }
  }


  /**
   * Wrapper function to render 'View More Rankings' button and 'Sub-score
   * rankings panel'. Calls render function for button, and renders Slidedown
   * if state.viewSubscoreRanks is true.
   *
   * @param  {Object} shareClass - shareclass object
   * @param  {Object} fund - fund object
   * @param  {Object} gefScoresState - score state object
   * @return {JSX} Wrapper for button and Slidedown
   */
  renderSubscoreMore = (shareClass, fund, gefScoresState) => {
    // if unscored, no button to show rankings.
    if (gefScoresState.isUnranked) {
      return null
    }
    return (
      <div>
        {this.renderViewSubscoreRanksButton(shareClass)}
        <SlideDown>
          {
            this.state.viewSubscoreRanks ?
              this.renderSubscoreRanks(
                shareClass,
                fund,
                gefScoresState
              ) :
              null
          }
        </SlideDown>
      </div>
    )
  }

  /**
   * Renders the 'More rankings' button that hides/displays the sub-score rank
   * panel. Styling adjusts based on if state.viewSubscoreRanks is true
   * or false. Also has a compare button
   *
   * @return {JSX} Button with state-updating onClick
   */
  renderViewSubscoreRanksButton = (shareClass) => {
    const label = !this.state.viewSubscoreRanks ?
      'View more rankings' :
      'View less'

    return(
      <div styleName='view-balance-policies-more-wrapper'>
        <button
          styleName='slidedown-button'
          title={label}
          onClick={() => {
            this.setState({
              viewSubscoreRanks: !this.state.viewSubscoreRanks
            })
          }}>
          {label}
          <LinkIcon
            faclass={
              this.state.viewSubscoreRanks ?
                'fa-angle-up' :
                'fa-angle-down'
            }
          />
        </button>
        { /* 
        <button
          styleName='compare-button'
          title={'Compare to other funds'}
          onClick={() => {
            if (this.props.cart && this.props.cart.results) {
              // has cart results
              let isInCartAlready = false
              let emptySpots = false
              this.props.cart.results.forEach((result) => {
                const stubId = result.shareclassStub.investment_vehicle_id
                if (stubId === shareClass.investment_vehicle_id) {
                  isInCartAlready = true
                } else if (result.id === 'N') {
                  emptySpots = true
                }
              })
              if (isInCartAlready) {
                // found the shareclass in the cart already
                this.props.cartChange(this.props.cart.results, {})
              } else {
                // did not find the shareclass in the cart already
                if (emptySpots) {
                  // cart not full - add the shareclass to the cart
                  this.props.cartChange(this.props.cart.results, shareClass)
                } else {
                  // cart was full - kick the last out of the cart
                  const size = this.props.cart.results.length-1
                  const newCart = this.props.cart.results.slice(0, size)
                  newCart.push({id: 'N', shareclassStub: {}})
                  this.props.cartChange(newCart, shareClass)
                }
              }
            } else {
              // did not have cart results
              this.props.cartChange([], shareClass)
            }
            // go to list with this new cart
            this.context.router.push(config.routes.clean)
          }}
        >
          Compare to other funds
          <LinkIcon />
        </button>
        */ }
      </div>
    )
  }

  /**
   * Render a container for a sub-score colorbar ranking visualization.
   *
   * @param  {String} sbScrLbl - sub-score label for container styling
   * @param  {Object} gefScoresState - score state object
   * @param  {String} colorbarStyle - string for color bar styling (un/ranked)
   * @param  {String} colorbarLabel - string for colorbar labeling (un/ranked)
   * @param  {<Img>} rankIcon - required icon img
   * @return {JSX} container for single colorbar data visualization
   */
  renderSubscoreRank = (subscoreId, gefScoresState, colorbarStyle, colorbarLabel, rankIcon) => {
    const _linkIcon = () => <LinkIcon nospace faclass='fa-ban'/>
    // balance or policies -rank-container
    const containerStyleName = `subscore-${subscoreId}-rank-container`

    const subscoreTitles = {
      A: 'Gender balance in leadership and workforce',
      B: 'Equal compensation and work life balance',
      C: 'Policies promoting gender equality',
      D: 'Commitment, transparency, and accountability',
    }

    const containerLabel = `Ranking: ${subscoreTitles[subscoreId]}`

    let fieldLabel = ''
    let rawFieldLabel = ''
    let norm = ''
    let label = ''
    let containerTooltipName = ''
    let containerRefName = ''

    // switch on active grouping ('rank', 'peer', or 'group')
    switch (this.state.activeGrouping) {
      case 'rank':
        label = 'All funds'
        fieldLabel = `subscore${subscoreId}PercentileRank`
        rawFieldLabel = `subscore${subscoreId}Rank`
        norm = gefScoresState.normAllScored
        containerTooltipName = `subscore${subscoreId}Rank`
        break
      case 'peer':
        label = 'Categories'
        fieldLabel = `subscore${subscoreId}PeerPercentileRank`
        rawFieldLabel = `subscore${subscoreId}PeerRank`
        norm = gefScoresState.normPeer
        containerTooltipName = `subscore${subscoreId}Peer`
        break
      case 'group':
        label = 'Groups'
        fieldLabel = `subscore${subscoreId}GroupPercentileRank`
        rawFieldLabel = `subscore${subscoreId}GroupRank`
        norm = gefScoresState.normGroup
        containerTooltipName = `subscore${subscoreId}Group`
        break
    }

    const capRefName = containerTooltipName.charAt(0).toUpperCase() +
      containerTooltipName.slice(1)
    containerRefName = `ref${capRefName}Container`

    let rank = _linkIcon()
    let rankStyle = 'percentile-null'
    let rawRank = (<em>N/A</em>)
    // if not unranked:
    if (!gefScoresState.isUnranked) {
      rank = gefScoresState[fieldLabel]
      rankStyle = format.scoreStyle(gefScoresState[fieldLabel])
      rawRank = `${gefScoresState[rawFieldLabel]}`
    }
    const allRankIcon = require('../../../static/images/GEF-icons-peer-rank.svg')

    return (
      <Col styleName='subscore-ranks-col' md={6} sm={12}>
        <div
          styleName='subscore-rank-container'
          data-multiline
          data-effect='solid'
          data-place='bottom'
          data-for={containerStyleName}
          data-html
          data-event='click focus'
          ref={(ref) => { this[containerRefName] = ref }}
          data-tip={
            this.generateTooltip(
              containerTooltipName,
              gefScoresState
            )
          }
        >
          <div styleName='subscores-col-title-wrap'>
            <img
              src={rankIcon}
              alt={containerLabel}
              styleName='inline-icon-sm'
            />
            <img
              src={allRankIcon}
              alt={containerLabel}
              styleName='inline-icon-sm'
            />
            <div styleName='subscores-col-title'>
              {containerLabel}
            </div>
          </div>
          <Flip top opposite when={this.state.groupsLoaded}>
            <div styleName='balance-policies-ranks-container-inner'>
              <div styleName='balance-policies-score-chart-wrap'>
                <div styleName='balance-policies-colorbar-wrap'>
                  <div styleName={'balance-policies-colorbar ' + rankStyle}/>
                  <div styleName='balance-policies-colorbar-figure'>
                    <div styleName={colorbarStyle}>
                      {rank}
                    </div>
                    <div styleName='balance-policies-colorbar-label'>
                      {colorbarLabel}
                    </div>
                  </div>
                </div>
              </div>
              <div styleName='balance-policies-score-copy'>
                {
                  this.renderRankDescription(
                    this.state.activeGrouping,
                    norm,
                    gefScoresState,
                    label,
                    rawRank
                  )
                }
              </div>
            </div>
          </Flip>
        </div>
        <ReactTooltip
          id={containerStyleName}
          globalEventOff='click'
          afterShow={
            () => { this.closeAllTooltipsExcept(containerRefName) }
          }
        />
      </Col>
    )
  }

  /**
   * Render sub-score rankings that are displayed in Slidedown when
   * state.viewSubscoreRanks is true. A grid of color sliders.
   *
   * @param  {Object} shareClass - shareclass object
   * @param  {Object} fund - fund object
   * @param  {Object} gefScoresState - score state object
   * @return {JSX} Grid of data visualizations
   */
  renderSubscoreRanks = (shareClass, fund, gefScoresState) => {
    // extra logic to deal with unranked funds
    // inline component with 'unranked' icon
    const { isUnranked } = gefScoresState
    let colorbarStyle = 'balance-policies-colorbar-'
    const suffix = isUnranked ? 'ban' : 'score'
    colorbarStyle += suffix
    const colorbarLabel = isUnranked ? 'Unranked' : 'percentile'
    // icons
    const subscoreAIcon = require(
      '../../../static/images/GEF-icons-gender-balance-peer-rank.svg'
    )
    const subscoreBIcon = require(
      '../../../static/images/GEF-icons-gender-equality-peer-rank.svg'
    )
    const subscoreCIcon = require(
      '../../../static/images/GEF-icons-gender-equality-policies-rank.svg'
    )
    const subscoreDIcon = require(
      '../../../static/images/GEF-icons-gender-equality-policies-score.svg'
    )
    return (
      <div styleName='subscore-ranks-wrap'>
        <div styleName='subscore-ranks-rows'>
          <Row styleName='subscore-ranks-row'>
            {
              this.renderSubscoreRank(
                'A',
                gefScoresState,
                colorbarStyle,
                colorbarLabel,
                subscoreAIcon
              )
            }
            {
              this.renderSubscoreRank(
                'B',
                gefScoresState,
                colorbarStyle,
                colorbarLabel,
                subscoreBIcon
              )
            }
          </Row>
          <Row styleName='subscore-ranks-row'>
            {
              this.renderSubscoreRank(
                'C',
                gefScoresState,
                colorbarStyle,
                colorbarLabel,
                subscoreCIcon
              )
            }
            {
              this.renderSubscoreRank(
                'D',
                gefScoresState,
                colorbarStyle,
                colorbarLabel,
                subscoreDIcon
              )
            }
          </Row>
        </div>
        <div styleName='subscore-ranks-group-control'>
          {this.renderGroupControl(this.state.activeGrouping)}
        </div>
      </div>
    )
  }

  /**
   * Wrapper function to render 'View More Button' and 'Stats panel'.
   * Renders button, and renders stats Slidedown if state.viewStats
   * is true.
   *
   * @param  {Object} shareClass - shareclass object
   * @param  {Object} fund - fund object
   * @param  {Object} gefScoresState - score state object
   * @return {JSX} Wrapper for button and Slidedown
   */
  renderMore = (shareClass, fund, gefScoresState) => {
    const label = !this.state.viewStats ? 'View more info' : 'View less'
    const iconClass = this.state.viewStats ? 'fa-angle-up' : 'fa-angle-down'
    return (
      <div styleName='more-stats'>
        <div styleName='view-more-wrapper'>
          <button
            styleName='view-more'
            title={label}
            onClick={this.clickViewStats}
          >
            {label}
            <LinkIcon faclass={iconClass} />
          </button>
        </div>
        <SlideDown styleName='slide-down'>
          {
            this.state.viewStats ?
              this.renderStats(shareClass, fund, gefScoresState) :
              null
          }
        </SlideDown>
      </div>
    )
  }

  /**
   * Render the stats grid that is displayed in the Slidedown when
   * state.viewStats is true.
   *
   * @param  {[type]} shareClass - the shareclass object
   * @param  {[type]} fund - the fund object
   * @param  {[type]} gefScoresState - the score state object
   * @return {JSX} Container of Rows of Cols that render stat entries
   */
  renderStats = (shareClass, fund, gefScoresState) => {
    /**
     * Render a stats column. Each column has a list of entries. Each entry is
     * an object with name, value, and possibly link. A container is created
     * that displays the labeled value and links out if needed.
     *
     * @param  {String} type
     * @param  {Array} entries - list of entry objects
     * @param  {Boolean} hasLine - true/false to display col-line div
     * @return {JSX} Col element with stats entry
     */
    function renderCol(type, entries, hasLine) {
      return (
        <Col xs={12} sm={6} styleName={'col-'+type+'-wrapper'}>
          {entries.map((entry, idx) => {
            return (
              <div
                key={idx}
                styleName='col-label-value'>
                <div styleName={'col-'+type}>
                  <div styleName='stats-label'>{entry.name}</div>
                  {
                    (entry.link) ? (
                      <Link
                        to={entry.link}
                        title={entry.value}
                        xstrong={true}>
                        <div styleName='stats-value-link'>
                          {entry.value}<LinkIcon />
                        </div>
                      </Link>
                    ) : <div styleName='stats-value'>{entry.value}</div>
                  }
                </div>
                {(hasLine && (idx !== entries.length-1)) ? (
                    <div styleName='col-line'/>
                  ) : null }
              </div>
            )
          })}
        </Col>
      )
    }

    return (
      <div styleName='stats'>
        <div styleName='stats-inner'>
          <div styleName='stats-totals'>
            <Row styleName='stats-header'>
              <Col xs={12}>
                <div styleName='stats-title'>
                  Mutual fund investment profile
                </div>
              </Col>
            </Row>
            <div styleName='line'/>
            <Row>
              {
                renderCol(
                  'left',
                  [
                    {
                      name: 'Shareclass ticker',
                      value:shareClass.ticker
                    }
                  ],
                  false
                )
              }
              {
                renderCol(
                  'right',
                  [
                    {
                      name: 'Data as of',
                      value: format.formatDate(shareClass.date)
                    }
                  ],
                  false
                )
              }
            </Row>
            <div styleName='line'/>
            <Row>
              {
                renderCol(
                  'left',
                  [
                    {
                      name: 'Shareclass name',
                      value:shareClass.name
                    }
                  ],
                  false
                )
              }
              <Col xs={12} sm={6} styleName='col-right-wrapper'>
                <div styleName='col-label-value'>
                  <div styleName='col-right'>
                    <div styleName='stats-label'>
                      % invested in stocks
                      <span
                        data-multiline
                        data-effect='solid'
                        data-place='bottom'
                        data-for='percent-rated'
                        data-html
                        // data-event='click focus'
                        // data-scroll-hide={false}
                        data-tip={
                          format.tooltipHtml(
                            `
                              The percent of the fund's holdings (including
                              stocks, bonds, and other asset types, and
                              including both long and short positions) made up
                              of direct stock investments. Because a fund's
                              gender equality scores are based on the direct
                              stock holdings in the portfolio, a fund must be 
                              at least 40% invested in stocks to be included
                              in our database.
                            `
                          )
                        }
                      >
                        <LinkIcon faclass='fa-info-circle' />
                        <ReactTooltip id='percent-rated'/>
                      </span>
                    </div>
                    <div styleName='stats-value'>
                      {format.perc(shareClass.percent_rated)}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div styleName='line'/>
            <Row>
              {
                renderCol(
                  'left',
                  [
                    {
                      name: 'Shareclass type',
                      value: format.legalType(shareClass.legal_type)
                    }
                  ],
                  false
                )
              }
              {
                renderCol(
                  'right',
                  [
                    {
                      name: 'Fund net assets',
                      value: format.money(
                        shareClass.fund_net_assets,
                        true,
                        shareClass.currency
                      )
                    }
                  ],
                  false
                )
              }
            </Row>
            <div styleName='line'/>
            <Row>
              {
                renderCol(
                  'left',
                  [
                    {
                      name: 'Fund family',
                      link: config.routes.families+'?q='+gefScoresState.dest,
                      value: shareClass.fund_family_name
                    }
                  ],
                  false
                )
              }
              {
                renderCol(
                  'right',
                  [
                    {
                      name: 'Fund category',
                      link: `
                        ${config.routes.list}?fdc=
                        ${encodeURIComponent(fund.morningstar_category_name)}
                      `,
                      value: shareClass.morningstar_category_name
                    }
                  ],
                  false
                )
              }
            </Row>
            <div styleName='line'/>
            <Row>
              {
                renderCol(
                  'left',
                  [
                    {
                      name: 'Domicile country',
                      value: format.market(shareClass.market)
                    }
                  ],
                  false
                )
              }
              {
                renderCol(
                  'right',
                  [
                    {
                      name: 'Morningstar-suggested benchmark',
                      value: fund.morningstar_primary_benchmark
                    }
                  ],
                  false
                )
              }
            </Row>
            <div styleName='line'/>
            <Row>
              {
                renderCol(
                  'left',
                  [
                    {
                      name: 'Total holdings',
                      value: format.number(shareClass.number_of_holding)
                    }
                  ],
                  false
                )
              }
              {
                renderCol(
                  'right',
                  [
                    {
                      name: 'Sustainability mandate',
                      value: format.boolean(
                        shareClass.socially_responsible_fund || "0"
                      )
                    }
                  ],
                  false
                )
              }
            </Row>
            <div styleName='line'/>
            <Row>
              {
                renderCol(
                  'left',
                  [
                    {
                      name: 'Non-diversification risk',
                      value: format.boolean(shareClass.non_diversified_fund)
                    }
                  ],
                  false
                )
              }
              {
                renderCol(
                  'right',
                  [
                    {
                      name: `
                        Member of The Forum for Sustainable and Responsible
                        Investment
                      `,
                      value: format.boolean(shareClass.ussif==='1.5')
                    }
                  ],
                  false
                )
              }
            </Row>
            <div styleName='line'/>
            <Row>
              {
                renderCol(
                  'left',
                  [
                    {
                      name: '# of holdings with Equileap scores',
                      value: gefScoresState.gefCount==='-1' ?
                        '0':
                        gefScoresState.gefCount
                    }
                  ],
                  false
                )
              }

              <Col xs={12} sm={6} styleName='col-right-wrapper'>
                <div styleName='col-label-value'>
                  <div styleName='col-right'>
                    <div styleName='stats-label'>
                      % Equileap coverage
                      <span
                        data-multiline
                        data-effect='solid'
                        data-place={'bottom'}
                        data-for={'gef-percent-rated'}
                        data-html
                        // data-event='click focus'
                        // data-scroll-hide={false}
                        data-tip={
                          format.tooltipHtml(
                            `
                              The percent of the fund's long-position holdings
                              (including stocks, bonds, and other asset types,
                              but excluding short positions) made up of stocks
                              that are covered by the Equileap Company Score
                              universe. Must be at least 33% for a fund to be
                              included in our rankings.
                            `
                          )
                        }
                      >
                        <LinkIcon faclass='fa-info-circle' />
                        <ReactTooltip id='gef-percent-rated'/>
                      </span>
                    </div>
                    <div styleName='stats-value'>
                      {
                        gefScoresState.gefPercentRated==='-100%' ?
                          '0%' :
                          gefScoresState.gefPercentRated
                      }
                      {
                        format.number(fund.gef_rank) === '-1' ?
                          (
                            <span
                              data-multiline
                              data-effect='solid'
                              data-place='bottom'
                              data-for='low-percent-rated'
                              data-html
                              // data-event='click focus'
                              ref={(ref) => { this.refLowPercentRated = ref }}
                              data-tip={
                                format.tooltipHtml(
                                  gefScoresState.gefPercentRated==='-100%' ?
                                    `
                                      None of this fund's holdings were scored
                                      by Equileap. We couldn't calculate any
                                      gender equality scores for this fund,
                                      and the fund was not included in our
                                      rankings.
                                    ` :
                                    `
                                      Less than 1/3 of this fund's holdings
                                      were scored by Equileap. We calculated
                                      gender equality scores for this fund
                                      based on
                                      the ${gefScoresState.gefPercentRated} of
                                      the fund holdings that had Equileap
                                      scores, but whenever the score coverage
                                      is below 1/3 (33%), we remove the fund
                                      from our rankings to increase accuracy.
                                    `
                                )
                              }
                            >
                              <LinkIcon
                                faclass='fa-exclamation-triangle fa-2x'
                              />
                              <ReactTooltip id='low-percent-rated'/>
                            </span>
                          ) :
                          null
                      }
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            <div styleName='line'/>
          </div>
        </div>
      </div>
    )
  }

  /**
   * Main render function
   * @return {JSX} page component
   */
  render() {
    if (!this.props.result) {
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    } else if (
      this.props.result && (
        !this.props.result.fund || !this.props.result.shareClass
      )
    ) {
      this.context.router.push(config.routes.notFound)
      return (
        <div styleName='main'>
          <Loader
            options={{scale: 0.70, top:'2.0rem'}}
            loaded={ false }
          />
        </div>
      )
    }

    const shareClass = this.props.result.shareClass
    const title = shareClass.fund_legal_name + ' | Gender equality score'
    const fund = this.props.result.fund
    const ticker = shareClass.ticker ? shareClass.ticker : 'N'
    const name = format.sanitize(shareClass.fund_legal_name)
    const urlStart = config.routes.fund+'/'+name+'/'+ticker
    const urlEnd = shareClass.fund_id+'/'+shareClass.investment_vehicle_id
    const url = config.domain+urlStart+'/gender-lens-score/'+urlEnd

    /**
     * This genScoreState logic should be moved to happen only once when the
     * fund object is loaded, rather than within the main render function.
     */

    /**
     * Generate a score state object by calculating normalized and formatted
     * figures for use in rendering functions
     *
     * @param  {Object} nrmlzrs - group divisors to normalize for percentile
     * rankings, from config
     * @param  {Object} fnd - fund object with fund values from api
     * @return {Object} score state object with almost everything needed to
     * create tooltips, render containers, etc.
     */
    const genScoreState = (nrmlzrs, fnd) => {
      const scores = {}
      const cat = fnd.morningstar_category_name
      const grp = fnd.category_group
      scores.dest = encodeURIComponent(fnd.fund_family_name)

      // "out of" figures
      scores.normAllScored = format.number(nrmlzrs.allScored)
      scores.normGroup = format.number(nrmlzrs.groups[grp])
      scores.normPeer = format.number(nrmlzrs.peers[cat])

      // coverage
      scores.gefCount = format.number(fnd.gef_count)
      scores.gefPercentRated = format.perc(fnd.gef_percent_rated)

      // overall scores
      scores.gefOverallScore = format.gefScore(fnd.gef_score)
      scores.gefUnnormalizedOverallScore = format.number(
        fnd.gef_score,
        false
      )

      // overall ranks
      scores.gefOverallRank = format.number(
        nrmlzrs.allScored - fnd.gef_rank + 1
      )
      scores.gefOverallPercentileRank = format.gefScore(
        fnd.gef_rank,
        nrmlzrs.allScored,
        0,
        1
      )

      // groups
      scores.gefOverallGroupRank = format.number(
        nrmlzrs.groups[grp] - fnd.gef_grp + 1
      )
      scores.gefOverallGroupPercentileRank = format.gefScore(
        fnd.gef_grp,
        nrmlzrs.groups[grp],
        0,
        1
      )

      // categories
      scores.gefOverallPeerRank = format.number(
        nrmlzrs.peers[cat] - fnd.gef_peer + 1
      )
      scores.gefOverallPeerPercentileRank = format.gefScore(
        fnd.gef_peer,
        nrmlzrs.peers[cat],
        0,
        1
      )

      // letter grade (based on group ranking)
      scores.gefOverallGroupGrade = format.gefGrade(
        format.gefScore(fnd.gef_grp, nrmlzrs.groups[grp], 0, 1, true)
      )

      // subscores
      const subscoreLabels = ['A', 'B', 'C', 'D']
      subscoreLabels.forEach((el)=> {
        const lwr = el.toLowerCase()
        // score for subscore, w/ decimal
        scores[`subscore${el}ScoreUnnormalized`] = format.number(
          fnd[`gef_score_${lwr}`],
          false
        )
        // score for subscore
        scores[`subscore${el}Score`] = format.gefScore(
          fnd[`gef_score_${lwr}`]
        )
        // overall rank for subscore
        scores[`subscore${el}Rank`] = format.number(
          nrmlzrs.allScored - fnd[`gef_rank_${lwr}`] + 1
        )
        // overall percentile rank for subscore
        scores[`subscore${el}PercentileRank`] = format.gefScore(
          fnd[`gef_rank_${lwr}`],
          nrmlzrs.allScored,
          0,
          1
        )
        // group rank for subscore
        scores[`subscore${el}GroupRank`] = format.number(
          nrmlzrs.groups[grp] - fnd[`gef_grp_${lwr}`] + 1
        )
        // group percentile rank for subscore
        scores[`subscore${el}GroupPercentileRank`] = format.gefScore(
          fnd[`gef_grp_${lwr}`],
          nrmlzrs.groups[grp],
          0,
          1
        )
        // category rank for subscore
        scores[`subscore${el}PeerRank`] = format.number(
          nrmlzrs.peers[cat] - fnd[`gef_peer_${lwr}`] + 1
        )
        // category percentile rank for subscore
        scores[`subscore${el}PeerPercentileRank`] = format.gefScore(
          fnd[`gef_peer_${lwr}`],
          nrmlzrs.peers[cat],
          0,
          1
        )
      })

      // show/hide flags
      scores.isUnranked = format.number(fnd.gef_rank) === '-1'
      scores.isUnscored = format.number(fnd.gef_score) === '-1'

      // grouping labels
      scores.morningstar_category_name = cat
      scores.category_group = grp

      // SRI/USSIF tooltips
      scores.sriTipText = (fnd.socially_responsible_fund === 'true') ?
        'Fund reports a Sustainability Mandate to Morningstar' :
        'No Sustainability Mandate'
      scores.sriTip = format.tooltipHtml(scores.sriTipText)
      scores.ussifTipText = 'Member of The Forum for Sustainable and Responsible Investment'
      scores.ussifTip = format.tooltipHtml(scores.ussifTipText)

      return scores
    }

    // hack in case zero funds from the category are ranked
    if (!config.gefScoreNormalizers.peers[fund.morningstar_category_name]) {
      config.gefScoreNormalizers.peers[fund.morningstar_category_name] = 0
    }
    const gefScoresState = genScoreState(config.gefScoreNormalizers, fund)

    // Trim trailing zeros from ranks (deals with inconsistent decimals)
    const rankNames = [
      'gefOverallPercentileRank',
      'gefOverallPeerPercentileRank',
      'gefOverallGroupPercentileRank',
      'subscoreAPercentileRank',
      'subscoreAPeerPercentileRank',
      'subscoreAGroupPercentileRank',
      'subscoreBPercentileRank',
      'subscoreBPeerPercentileRank',
      'subscoreBGroupPercentileRank',
      'subscoreCPercentileRank',
      'subscoreCPeerPercentileRank',
      'subscoreCGroupPercentileRank',
      'subscoreDPercentileRank',
      'subscoreDPeerPercentileRank',
      'subscoreDGroupPercentileRank',
    ]

    rankNames.map((x) => {
      gefScoresState[x] = format.dropStringTrailingZero(gefScoresState[x])
      return true
    })

    // subscores are attached to fund for use in returns component
    // (not really normed. to clean up)
    fund.gef_score_norm = gefScoresState.gefOverallScore
    // fund.gef_score_a_norm = gefScoresState.subscoreAScore
    // fund.gef_score_b_norm = gefScoresState.subscoreBScore
    // fund.gef_score_c_norm = gefScoresState.subscoreCScore
    // fund.gef_score_d_norm = gefScoresState.subscoreDScore

    // Flag to display the diversity EEO if a fund has one to display
    const eeoStatement = config.ussifFundsDiversityEeo[fund.fund_id] || false

    return (
      <div>
        {container.helmet(title, '', url)}

        { /* FundName */ }
        <FundName
          shareClass={shareClass}
          pathname={this.props.location.pathname}
        />

        { /* Overall score and rank; subscores; subscore ranks */ }
        <ContainerDivs>


          {
            fund.grade_gender_equality === 2.5 ?
              <FundEngagementGradeBox issueId='gef' /> :
              <div>
                {this.renderOverallScores(shareClass, fund, gefScoresState)}

                {this.renderSubscoreScores(shareClass, fund, gefScoresState)}

                {this.renderSubscoreMore(shareClass, fund, gefScoresState)}

              </div>
          }

          <br/>
          <br/>
          <br/>
          <br/>
          <InlineSignup />
          <br/>
          <br/>

        </ContainerDivs>

        { /* IYV "report card" */ }
        <IyvScorecard fund={fund} shareClass={shareClass} />


        { /* Diversity-EEO statement + Company lists */ }
        <div styleName='container'>
          <div styleName='container-inner'>
            { /* if the fund has a diversity-EEO statement from US-SIF */
              eeoStatement ?
                (
                  <DiversityEeoStatement
                    fundId={fund.fund_id}
                    shareclassId={shareClass.investment_vehicle_id}
                    shareName={shareClass.name}
                  />
                ) :
                null
            }
            { /* if the fund is scored: show list of top/bottom holdings */
              !gefScoresState.isUnscored && fund.grade_gender_equality !== 2.5 ?
                (
                  <CompanyList
                    currency={shareClass.currency}
                    holdings={fund.holdings}
                    fholdings={fund.fundholdings}
                  />
                ) :
                null
            }
            { /* button that shows/hides the "stats" panel */
              this.renderMore(shareClass, fund, gefScoresState)
            }
          </div>
        </div>

        { /* Get started panel */ }
        <GetStartedInput />

        { /* Returns, CTAs */ }
        <FundShareTakeAction fund={fund} shareClass={shareClass} url={url}/>
      </div>
    )
  }
}
